module.exports = __webpack_public_path__ + "static/media/concert2.f690daba.jpg";